import { render } from "./PersonView.vue?vue&type=template&id=5b454168&ts=true"
import script from "./PersonView.vue?vue&type=script&lang=ts"
export * from "./PersonView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__